import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideBadgeCheck, lucideChevronsUpDown, lucideCreditCard, lucideLogOut } from '@ng-icons/lucide';
import { HlmAvatarImports } from '@spartan-ng/helm/avatar';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { HlmSidebarImports, HlmSidebarService } from '@spartan-ng/helm/sidebar';
import { UserService } from '@core/data/service/user.service';
import { AuthService } from '@core/services/auth/auth.service';

interface NavUserItem {
  id: string;
  title: string;
  icon: string;
  link: string;
  hasAuthority?: string;
}

/** The signed-in user in the sidebar footer, with the account menu. */
@Component({
  selector: 'app-nav-user',
  templateUrl: './nav-user.component.html',
  imports: [
    NgIcon,
    HlmAvatarImports,
    HlmDropdownMenuImports,
    HlmSidebarImports
  ],
  providers: [provideIcons({ lucideBadgeCheck, lucideChevronsUpDown, lucideCreditCard, lucideLogOut })]
})
export class NavUserComponent {
  private userService = inject(UserService);
  private authService = inject(AuthService);
  private router = inject(Router);
  private sidebarService = inject(HlmSidebarService);

  protected readonly menuSide = computed(() => (this.sidebarService.isMobile() ? 'top' : 'right'));

  private readonly menuItems: NavUserItem[] = [
    { id: 'account', title: 'Account', icon: 'lucideBadgeCheck', link: '/settings/account' },
    { id: 'billing-usage', title: 'Billing & usage', icon: 'lucideCreditCard', link: '/settings/billing-usage', hasAuthority: 'VIEW_PAGE_BILLING' }
  ];

  readonly user = computed(() => this.userService.currentUser);
  readonly name = computed(() => `${ this.user().firstName ?? '' } ${ this.user().lastName ?? '' }`.trim());
  readonly initials = computed(() => ((this.user().firstName?.charAt(0) ?? '') + (this.user().lastName?.charAt(0) ?? '')).toUpperCase());
  readonly items = computed(() => this.menuItems.filter(item => !item.hasAuthority || this.user().hasAuthority(item.hasAuthority)));

  open(item: NavUserItem) {
    this.router.navigateByUrl(item.link);
  }

  logout() {
    this.authService.logout();
  }
}
